import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppFloat } from './WhatsAppFloat';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-241" data-mp="2bgrl6h7dyge">
      <Navbar data-id="element-242" data-mp="gzlc8fztgk1t" />
      <main className="flex-1" data-id="element-243" data-mp="h03655z0am6k">
        <Outlet data-id="element-244" data-mp="h0d014n69dhj" />
      </main>
      <Footer data-id="element-245" data-mp="c7a10gzmlbty" />
      <WhatsAppFloat data-id="element-246" data-mp="c6s8nvg33hrb" />
    </div>;
}